import { ajax } from "../services/ajax";
import { api } from "../constants";

export const getAdsListRequest = channelId => ajax.get(api.endpoints.ads.list(channelId));

export const getAdRequest = id => new Promise((resolve, reject) => {
  Promise.all([
    ajax.get(api.endpoints.ads.get(id)),
    ajax.get(api.endpoints.ads.getSpecs(id))
  ])
    .then(responses =>
      resolve({
        ...responses[0].data,
        spec: responses[1].data
      })
    )
    .catch(err => {
      reject(err)
    });
})

export const deleteAdRequest = id => ajax.post(api.endpoints.ads.remove, {
  id
});

export const saveAdRequest = ad => new Promise((resolve, reject) => {
  const formData = new FormData();
  const { id, name, quality, link, type, country, privilege, duration, active = false } = ad;
  formData.append('data', JSON.stringify({
    id, name, quality, link, type, country, privilege, active, duration,
    renewTrack: !!ad.file,
    renewPic: !!ad.coverFile.file
  }));
  if (ad.file && ad.file.file) formData.append('track', ad.file.file);
  if (ad.coverFile && ad.coverFile.file) formData.append('cover', ad.coverFile.file);
  const saveAdRequestArray = [
    ajax.post(api.endpoints.ads.save, formData),
  ]
  if (Object.keys(ad.spec).length) saveAdRequestArray.push(ajax.post(api.endpoints.ads.saveSpec, ad.spec));
  Promise.all(saveAdRequestArray)
    .then(resolve)
    .catch(reject)
})


export const getAdsReport = args => {
  return ajax.get(api.endpoints.report.ads(args))
}